'client-only';

import { dayjs } from '@/utils/date/dayjs';

import { type WinbackPromotion } from './types';

export const useWinback = (promotion?: WinbackPromotion) => {
  const startsAt = promotion?.startsAt ? dayjs(promotion.startsAt) : undefined;
  const endsAt = promotion?.endsAt ? dayjs(promotion.endsAt) : undefined;
  const cutoffDate = endsAt?.subtract(3, 'day');
  const now = dayjs();

  const promotionIsActive = Boolean(
    promotion?.isActive &&
      startsAt &&
      cutoffDate &&
      startsAt.isBefore(now) &&
      cutoffDate.isAfter(now),
  );

  return {
    shouldDisplayWinback: promotionIsActive,
    expirationDisplayDate: cutoffDate?.format('MMMM D'),
    discountAmount: promotion?.amountInDollars,
    banner: promotion?.banner,
  };
};
